import type { TreeProps } from 'antd'
import React, { useState, useEffect, useContext, useRef } from 'react'
import { Button, Tree } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { Scrollbars, ListTableContext, ModalContext, postMsg } from 'src/components'
import { $api } from 'src/plugins'

const BS026 = () => {
  const modal = useContext(ModalContext)
  const table = useContext(ListTableContext)

  const [menuData, setMenuData] = useState<any>({})
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([])
  const targetKeys = useRef<React.Key[]>()

  useEffect(() => {
    const [RoleId, AppCode, EntryCode] = table?.selectedRow?.ID.split('_') ?? []
    $api['app/getDataByPost'](
      { RoleId, AppCode, EntryCode },
      { url: '/OP/UserRole/GetTreePermissionForms' }
    ).then(res => {
      if (res) {
        setMenuData(res)
        setCheckedKeys(res.checkLastKey)
      }
    })
  }, [])

  const handleSubmit = () => {
    const [RoleId, AppCode, EntryCode] = table?.selectedRow?.ID.split('_') ?? []
    $api['app/getDataByPost'](
      {
        CheckKeys: targetKeys.current ?? menuData.checks,
        RoleId,
        AppCode,
        EntryCode
      },
      { url: '/OP/UserRole/SetRolePerm' }
    ).then((res: any) => {
      if (res) {
        postMsg('操作成功')
        modal?.close()
        table?.reload()
      }
    })
  }

  const handleCheckedChange: TreeProps<any>['onCheck'] = (keys, node) => {
    const checked = keys as React.Key[]
    setCheckedKeys(checked)
    targetKeys.current = [...checked, ...(node.halfCheckedKeys ?? [])]
  }

  return (
    <React.Fragment>
      <Scrollbars autoHeight autoHeightMax='70vh'>
        <Tree
          checkable
          multiple
          treeData={menuData.rolePermissionTreeModels}
          checkedKeys={checkedKeys}
          onCheck={handleCheckedChange}
        />
      </Scrollbars>
      <div className='text-right pd-t12 mg-t12 border-top'>
        <Button type='primary' icon={<SaveOutlined />} onClick={handleSubmit}>保存</Button>
      </div>
    </React.Fragment>
  )
}

export default BS026